import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-consultancy-booking.tsx
var LazyConsultancyBooking = lazy(() => import("./consultancy-booking-B2KNBnyV.js").then((n) => n.n).then((module) => ({ default: module.ConsultancyBooking })));
function ConsultancyBooking({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultancy-booking" }),
		children: /* @__PURE__ */ jsx(LazyConsultancyBooking, { ...props })
	});
}
function ConsultancyBookingContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultancy-booking" }),
		children: /* @__PURE__ */ jsx(LazyConsultancyBooking, { ...props })
	});
}
var useConsultancyBookingContent = () => {
	return useMemo(() => ({ consultancyBooking: { component: ConsultancyBookingContent } }), []);
};
//#endregion
export { ConsultancyBooking, useConsultancyBookingContent };
